/**
 * Where the user's dev-mode switch lives: `localStorage`, under a flat key.
 *
 * Flat on purpose, not per user like `favorites`: dev mode is a support tool, and support means
 * impersonating an organizer, which is a different user. Keeping the switch flat means it is still
 * on the moment impersonation ends, with nothing to turn back on. Note this is about the SWITCH
 * only: eligibility travels separately, in `dev-mode-eligibility.ts` (B2B-2345).
 *
 * No cookie, unlike `dark-mode-preference`: nothing reads this before React boots, so there is
 * nothing for a cookie to serve.
 */
export const DEV_MODE_STORAGE_KEY = 'xceed-dev-mode';

// Guarded: a WebView with storage disabled throws on access rather than returning null, and a
// debugging convenience is never worth breaking a launch over. "Off" is the safe answer.
export const readDevModeChoice = (): boolean => {
  try {
    return globalThis.localStorage.getItem(DEV_MODE_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const persistDevModeChoice = (isOn: boolean): void => {
  try {
    globalThis.localStorage.setItem(DEV_MODE_STORAGE_KEY, String(isOn));
  } catch {
    // Not persisted; the in-memory state still applies for this session.
  }
};
